import { keepPreviousData as e, useMutation as t, useQuery as n, useQueryClient as r } from "@tanstack/react-query";
import { http as i, toListPage as a, toQueryParams as o } from "@frontends/data-access-spg-api";
//#region src/lib/api/mappers.ts
function s(e) {
	return {
		model: e.model,
		lengthSeconds: e.length_seconds,
		alignTo: e.align_to,
		duePosition: e.due_position,
		dueWindowSeconds: e.due_window_seconds,
		startsAt: e.starts_at
	};
}
function c(e) {
	return {
		model: e.model,
		length_seconds: e.lengthSeconds,
		align_to: e.alignTo,
		due_position: e.duePosition,
		due_window_seconds: e.dueWindowSeconds,
		starts_at: e.startsAt
	};
}
function l(e) {
	return {
		id: e.id,
		instanceId: e.instance_id,
		name: e.name,
		enabled: e.enabled,
		measurement: {
			metric: e.measurement.metric,
			threshold: e.measurement.threshold,
			instruments: e.measurement.instruments
		},
		period: s(e.period),
		schedule: e.schedule,
		warning: {
			schedule: e.warning.schedule,
			period: e.warning.period && s(e.warning.period)
		},
		mode: e.mode,
		graceSeconds: e.grace_seconds,
		settlingSeconds: e.settling_seconds,
		anchorPolicy: e.anchor_policy,
		missingAnchor: e.missing_anchor,
		sanction: {
			kind: e.sanction.kind,
			durationSeconds: e.sanction.duration_seconds
		},
		priority: e.priority,
		minCoverage: e.min_coverage,
		minCohort: e.min_cohort,
		maxPerRun: e.max_per_run
	};
}
function u(e) {
	return {
		instance_id: e.instanceId,
		name: e.name,
		enabled: e.enabled,
		measurement: {
			metric: e.measurement.metric,
			threshold: e.measurement.threshold,
			instruments: e.measurement.instruments
		},
		period: c(e.period),
		schedule: e.schedule,
		warning: {
			schedule: e.warning.schedule,
			period: e.warning.period && c(e.warning.period)
		},
		mode: e.mode,
		grace_seconds: e.graceSeconds,
		settling_seconds: e.settlingSeconds,
		anchor_policy: e.anchorPolicy,
		missing_anchor: e.missingAnchor,
		sanction: {
			kind: e.sanction.kind,
			duration_seconds: e.sanction.durationSeconds
		},
		priority: e.priority,
		min_coverage: e.minCoverage,
		min_cohort: e.minCohort,
		max_per_run: e.maxPerRun
	};
}
function d(e) {
	return {
		id: e.id,
		stage: e.stage,
		status: e.status,
		abortReason: e.abort_reason,
		firedAt: e.fired_at,
		startedAt: e.started_at,
		finishedAt: e.finished_at,
		cohort: e.cohort,
		measured: e.measured,
		violations: e.violations,
		applied: e.applied
	};
}
function f(e) {
	return {
		abortReason: e.abort_reason,
		cohort: e.cohort,
		measured: e.measured,
		verdicts: e.verdicts.map((e) => ({
			action: e.action,
			evidence: e.evidence,
			givenUpReason: e.given_up_reason,
			participationId: e.participation_id,
			person: {
				platform: e.user.platform,
				externalId: e.user.external_id,
				displayName: e.user.display_name,
				username: e.user.username
			},
			status: e.status,
			windowFrom: e.window_from,
			windowTo: e.window_to
		}))
	};
}
function p(e) {
	return {
		sanction: f(e.sanction),
		sanctionsToApply: e.sanctions_to_apply,
		warning: e.warning && f(e.warning)
	};
}
//#endregion
//#region src/lib/api/retentionRulesApi.ts
var m = (e) => `/retention-rules/${encodeURIComponent(e)}`;
async function h(e) {
	let { data: t } = await i.get("/retention-rules", { signal: e });
	return t.map(l);
}
async function g(e, t) {
	let { data: n } = await i.get(m(e), { signal: t });
	return l(n);
}
async function _(e) {
	let { data: t } = await i.post("/retention-rules", u(e));
	return l(t);
}
async function v(e, t) {
	let { data: n } = await i.put(m(e), u(t));
	return l(n);
}
async function y(e, t) {
	let { data: n } = await i.post(e ? `${m(e)}/dry-run` : "/retention-rules/dry-run", u(t));
	return p(n);
}
async function b(e, t) {
	await i.patch(m(e), { enabled: t });
}
async function x(e) {
	await i.delete(m(e));
}
async function S(e, t, n) {
	let { data: r } = await i.get(`${m(e)}/runs`, {
		params: o(t),
		signal: n
	});
	return {
		data: r.data.map(d),
		total: r.total
	};
}
async function C(e) {
	let { data: t } = await i.get("/retention-rules/health", { signal: e });
	return t.map((e) => ({
		ruleId: e.rule_id,
		instanceId: e.instance_id,
		unsanctioned: e.unsanctioned,
		stuck: e.stuck,
		pending: e.pending,
		lastRun: e.last_run && {
			id: e.last_run.id,
			stage: e.last_run.stage,
			status: e.last_run.status,
			abortReason: e.last_run.abort_reason,
			firedAt: e.last_run.fired_at
		}
	}));
}
//#endregion
//#region src/lib/queries.ts
var w = "all", T = {
	all: ["retention-rules"],
	list: () => [...T.all, "list"],
	detail: (e) => [
		...T.all,
		"detail",
		e
	],
	health: () => [...T.all, "health"],
	runs: (e, t) => [
		...T.all,
		"runs",
		e,
		...t ? [t] : []
	]
};
function E(e, t) {
	return (t.instance === "all" || e.instanceId === t.instance) && e.name.toLowerCase().includes(t.query.toLowerCase());
}
function D(e, t) {
	return n({
		queryKey: T.list(),
		queryFn: ({ signal: e }) => h(e),
		select: (n) => a(n.filter((e) => E(e, t)), e, (e, t) => e[t])
	});
}
function O() {
	return n({
		queryKey: T.list(),
		queryFn: ({ signal: e }) => h(e)
	});
}
function k(e) {
	return n({
		queryKey: T.detail(e),
		queryFn: ({ signal: t }) => g(e, t)
	});
}
function A(t, r) {
	return n({
		queryKey: T.runs(t, r),
		queryFn: ({ signal: e }) => S(t, r, e),
		placeholderData: e
	});
}
function j() {
	return n({
		queryKey: T.health(),
		queryFn: ({ signal: e }) => C(e),
		refetchInterval: 6e4
	});
}
//#endregion
//#region src/lib/mutations.ts
function M() {
	let e = r();
	return t({
		mutationFn: _,
		onSuccess: () => e.invalidateQueries({ queryKey: T.list() })
	});
}
function N() {
	let e = r();
	return t({
		mutationFn: ({ id: e, rule: t }) => v(e, t),
		onSuccess: (t) => (e.setQueryData(T.detail(t.id), t), Promise.all([e.invalidateQueries({ queryKey: T.list() }), e.invalidateQueries({ queryKey: T.health() })]))
	});
}
function P() {
	return t({ mutationFn: ({ id: e, rule: t }) => y(e, t) });
}
function F() {
	let e = r();
	return t({
		mutationFn: ({ id: e, enabled: t }) => b(e, t),
		onSuccess: (t, { id: n }) => Promise.all([e.invalidateQueries({ queryKey: T.detail(n) }), e.invalidateQueries({ queryKey: T.list() })])
	});
}
function I() {
	let e = r();
	return t({
		mutationFn: x,
		onSuccess: (t, n) => (e.removeQueries({ queryKey: T.detail(n) }), e.invalidateQueries({ queryKey: T.list() }))
	});
}
//#endregion
export { w as ALL_INSTANCES, T as retentionRulesQueryKeys, O as useAllRetentionRulesQuery, M as useCreateRetentionRuleMutation, I as useDeleteRetentionRuleMutation, P as useDryRunRetentionRuleMutation, j as useRetentionHealthQuery, k as useRetentionRuleQuery, D as useRetentionRulesQuery, A as useRuleRunsQuery, F as useSetRetentionRuleEnabledMutation, N as useUpdateRetentionRuleMutation };
